import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import {
  TextField,
  Grid
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const Form  = ({ error, variant }) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item  style={ { marginBottom: '10px' } }>
        <Controller
          name='content'
          render={ ({ field }) => (
            <TextField
              { ...field }
              label={ t('managerialDecisionComments.form.content') }
              variant={ variant }
              required
              multiline
              fullWidth
            />
          ) }
        />
      </Grid>
      { error &&
        <Alert severity='error'>
          {error}
        </Alert>
      }
    </>
  );
};

export default Form;